import UserAvatar from './UserAvatar';
import CustomSelect from './CustomSelect';
import { ChevronRightIcon, PlusIcon, CopyIcon, DeleteIcon } from './Icons';
import { TYPE_CONFIG, STATUS_LABELS, LOCATION_OPTIONS } from '../constants';
import { findAssignee, isContainerType, getAllowedChildTypes } from '../utils';

export default function BacklogTreeItem({ node, depth, expandedIds, onToggle, onClickItem, onAddChild, onLocationChange, onDeleteItem, users, showToast }) {
  const config = TYPE_CONFIG[node.type] || TYPE_CONFIG.task;
  const Icon = config.icon;
  const assignee = findAssignee(users, node.assigneeId);
  const isContainer = isContainerType(node.type);
  const hasChildren = node.children && node.children.length > 0;
  const isExpanded = expandedIds[node.id];
  const childTypes = getAllowedChildTypes(node.type);
  const statusLabel = STATUS_LABELS[node.status] || 'Not Started';

  return (
    <>
      <div className={`backlog-tree-item${isContainer ? ' backlog-tree-item--container' : ''}`}>
        {/* Gutter: full indent area + chevron — clicking toggles expand/collapse */}
        <div
          className={`backlog-tree-gutter${isContainer ? ' backlog-tree-gutter--toggle' : ''}`}
          style={{ width: `${depth * 24 + 64}px` }}
          onClick={() => isContainer && onToggle(node.id)}
        >
          {isContainer && (
            <span className={`backlog-tree-chevron${isExpanded ? ' backlog-tree-chevron--open' : ''}`}>
              <ChevronRightIcon size={16} />
            </span>
          )}
        </div>

        {/* Content: type icon + title — clicking opens edit modal */}
        <div className="backlog-tree-content" onClick={() => onClickItem(node)}>
          <div className="backlog-item-type" style={{ borderColor: config.color }}>
            <Icon size={16} style={{ color: config.color }} />
          </div>
          <div className="backlog-item-info" style={{ flex: 1, minWidth: 0 }}>
            <div className="backlog-item-info-top">
              {node.readableId && (
                <span
                  className="backlog-item-rid"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(`${node.readableId}-${node.title}`);
                    showToast('ID copied', 'success');
                  }}
                >
                  {node.readableId} <CopyIcon size={10} />
                </span>
              )}
            </div>
            <span className="backlog-item-title">{node.title}</span>
            {node.description && (
              <span className="backlog-item-desc">{node.description}</span>
            )}
          </div>
        </div>

        {/* Meta: badges and action buttons */}
        <div className="backlog-item-meta">
          {isContainer && hasChildren && (
            <span className="backlog-tree-child-count">{node.children.length}</span>
          )}
          {assignee && (
            <UserAvatar user={assignee} size={28} showStatus={false} />
          )}
          {node.storyPoints != null && (
            <span className="sprint-item-points">{node.storyPoints}</span>
          )}
          <span className={`status-badge status-${node.status}`}>
            {statusLabel}
          </span>
          {onLocationChange && (
            <div onClick={(e) => e.stopPropagation()}>
              <CustomSelect
                value={node.location || 'backlog'}
                onChange={(val) => onLocationChange(node.id, val)}
                options={LOCATION_OPTIONS}
                size="sm"
                compact
              />
            </div>
          )}
          {childTypes.length > 0 && (
            <button
              className="backlog-tree-add-child"
              title="Add child"
              onClick={(e) => {
                e.stopPropagation();
                onAddChild(node);
              }}
            >
              <PlusIcon size={14} />
            </button>
          )}
          {onDeleteItem && (
            <button
              className="backlog-tree-delete"
              title="Delete"
              onClick={(e) => {
                e.stopPropagation();
                onDeleteItem(node);
              }}
            >
              <DeleteIcon size={14} />
            </button>
          )}
        </div>
      </div>
      {isExpanded && hasChildren && node.children.map((child) => (
        <BacklogTreeItem
          key={child.id}
          node={child}
          depth={depth + 1}
          expandedIds={expandedIds}
          onToggle={onToggle}
          onClickItem={onClickItem}
          onAddChild={onAddChild}
          onLocationChange={onLocationChange}
          onDeleteItem={onDeleteItem}
          users={users}
          showToast={showToast}
        />
      ))}
    </>
  );
}
